export class ChiTietDuocNhanKCT {
    "ten": string;
    "thoiGian": string;
    "mucTien": number;
    "quyThuLaoThangStr": string;
    "quyThuLaoThang": number;
    "thang": number;

    constructor(thang: number) {        
        this.ten = `Tháng ${thang}`;
        this.thoiGian = `Tháng ${thang}`;
        this.mucTien = 0;
        this.quyThuLaoThangStr = "";
        this.quyThuLaoThang = 0;
        this.thang = thang;
    }
}

export interface ThangKhongTronKCT {
    soThang: number;
    soNgayThucTe: number;
    soNgayQuyDinh: number;
    ghiChu?: string;
}

export interface TinhThuLaoKCTItem {
    idNhanVien: number;
    id: number;
    hoTen: string;
    tenChucVu: string;
    tyLe: number;
    thuLaoTheoChucDanh: number;
    tongThuLao: number;
    mucLuongCB: number;
    thuLaoTamUngMotThang: number;
    soThangLamViec: number;
    soThangTron: number;
    soNgayThucTe?: number;
    soNgayQuyDinh?: number;
    dsThangKhongTron?: ThangKhongTronKCT[];
    soTienDaNhan: number;
    soTienDuocNhan: number;
    soTienConDuocNhan: number;
    soTienThueDaDong?: number;
    soTienThuePhaiDong?: number;
    ghiChu?: string;
    chiTietDaNhan?: any[];
    chiTietDuocNhan?: any[];
}

